<template>
    <span class="text-white text-center flex flex-col font-bold text-xs pl-1 w-10 lg:w-6">
        <span class="my-auto">{{ selection.start_number }}</span>
    </span>

    <span class="flex text-white flex-col justify-center p-1 pl-0 w-0 fold:w-14" v-if="selection.silk_image_path !== 'No Image'">
        <span class="py-1 w-10 sm:w-14 h-14 hidden fold:flex items-center justify-center">
            <img v-if="selection.jockey?.team" class="" :src="asset('images/racingleague/rl-' + selection.jockey.team + '.svg')" :class="[selection.jockey.team == 'scotland' ? 'w-7' : 'w-10']"/>
            <img v-else class="w-10" :src="selection.silk_image_path" />
        </span>
    </span>

    <span class="flex text-white flex-col justify-center p-1 sm:pl-1 w-full">
        <span class="text-xs text-white flex">{{ selection.race.start_time }} </span>
        <span class="text-[12px] lg:text-base flex fold:mr-1 break-all font-bold w-fit h-fit max-h-9 overflow-hidden" :class="[$page.props.settings.site_name == 'Racing Stars' ? 'text-racing-stars-yellow' : 'text-white']">{{ selection.horse ? selection.horse.name : 'Reserve' }}</span>
        <!-- <span class="hidden lg:flex text-xs"> -->
            <span v-if="selection.jockey" class="mr-2 text-xs">J: {{ selection.jockey.name }}</span>
            <span v-if="selection.horse.trainer" class="text-xs">T: {{ selection.horse.trainer.name }}</span>
            <Popper placement="top" arrow="true" style="--popper-theme-background-color:#030712;--popper-theme-background-color-hover:#030712;" class="cursor-pointer">
                <div class="hidden md:flex my-auto text-sm font-semibold mt-1"><InformationCircleIcon class="text-white h-4 w-4 my-auto mr-1"/>Information</div>
                <template #content>
                    <div class="hidden md:flex flex-col bg-gray-950 my-2 p- rounded-b text-xs text-white w-full">
                        <div class="flex mb-2">
                            <p class="font-bold text-sm">Horse Name: </p>
                            <p class="my-auto ml-1 font-medium text-sm">{{ selection.horse.name }}</p>
                        </div>
                        <div v-if="selection.horse && selection.horse.trainer" class="flex mb-2">
                            <strong>T: </strong>
                            <p class="my-auto ml-1 font-medium">{{ selection.horse.trainer.name }}</p>
                        </div>
                        <div class="flex mb-2">
                            <div class="flex mr-2">
                                <strong class="text-white mr-1">Weight: </strong>
                                <p class="font-medium">{{ selection.weight }}</p>
                            </div>
                            <div v-if="selection.horse && selection.horse.rating" class="flex mr-2">
                                <strong class="mr-1">Rating: </strong>
                                <p class="font-medium">{{ selection.horse.rating }}</p>
                            </div>
                            <div class="flex mr-2">
                                <strong class="mr-1">Age: </strong>
                                <p class="font-medium">{{ selection.horse.age }}</p>
                            </div>
                            <div v-if="selection.horse" class="flex mr-2">
                                <strong class="mr-1">Form: {{ selection.horse ? selection.horse.form : '' }}</strong>
                                <p class="font-medium">{{ selection.horse ? selection.horse.form : '' }}</p>
                            </div>
                            <div class="flex mr-2">
                                <strong class="mr-1">Draw: </strong>
                                <p class="font-medium">{{ selection.draw }}</p>
                            </div>
                        </div>
                    </div>
                </template>
            </Popper>
        <!-- </span> -->
    </span>



    <div v-if="getPosition(selection) != 0 || selection.forecast_odds_description || getPoints(selection) != 0" class="flex items-end justify-center text-center mr-1 my-auto h-10">
        <div :class="getStyles(selection).styles" class="dark:bg-gray-600 text-white p-2 rounded-t w-20 text-center text-xs" v-if="hasResult(selection)">{{ getPosition(selection) }}</div>

        <div class="dark:text-white px-0 my-auto rounded-t w-fit text-center font-bold text-xs" v-else-if="$page.props.features.stars_not_odds === false">{{ getOddsDescription(selection.forecast_odds_description) }}</div>
        <div class="dark:text-white px-0 my-auto rounded-t w-fit text-center font-bold text-xs" v-else>


             <div class="w-full flex flex-row text-white text-center font-bold text-xs" v-if="$page.props.features.stars_not_odds === true" >
                <div class="flex">
                    <template v-for="star in Math.floor(selection.star_rating)">
                        <StarIcon class="text-white h-5 w-3 mr-0.5 my-1.5 stroke-1 stroke-current" />
                    </template>
                    <template v-if="selection.star_rating - Math.floor(selection.star_rating) > 0">
                        <svg class="text-white h-5 w-3 mr-0.5 my-1.5"
                             viewBox="-0.5 -0.35 5.2 5.2"
                             version="1.1"
                             id="svg5"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:svg="http://www.w3.org/2000/svg">
                            <defs
                                id="defs2">
                                <clipPath
                                    clipPathUnits="userSpaceOnUse"
                                    id="clipPath954">
                                    <rect
                                        style="opacity:0.643512;fill:#ffffff;fill-opacity:1;stroke:#ffffff;stroke-width:0.2;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:0;paint-order:markers stroke fill"
                                        id="rect956"
                                        width="3.7340364"
                                        height="7.1398091"
                                        x="259.22318"
                                        y="96.550743"
                                        ry="1.8670182" />
                                </clipPath>
                            </defs>
                            <g
                                id="layer1"
                                transform="translate(-263.66324,-98.488591)">
                                <path
                                    d="m 265.50968,98.803649 c 0.0794,-0.243681 0.42413,-0.243681 0.50324,0 l 0.2831,0.871008 a 0.26458333,0.26458333 0 0 0 0.25135,0.182563 h 0.91599 c 0.25638,0 0.36275,0.32808 0.15558,0.4789 l -0.74084,0.53816 a 0.26458333,0.26458333 0 0 0 -0.0963,0.2958 l 0.28311,0.87101 c 0.0794,0.24368 -0.19976,0.44662 -0.40746,0.29581 l -0.74083,-0.53817 a 0.26458333,0.26458333 0 0 0 -0.31089,0 l -0.74083,0.53817 c -0.20743,0.15081 -0.48631,-0.0521 -0.4072,-0.29581 l 0.28311,-0.87101 a 0.26458333,0.26458333 0 0 0 -0.0963,-0.2958 l -0.74057,-0.5379 c -0.20717,-0.15081 -0.10054,-0.478896 0.15558,-0.478896 h 0.91572 a 0.26458333,0.26458333 0 0 0 0.25162,-0.182562 l 0.2831,-0.871009 z"
                                    id="path132"
                                    style="fill:none;fill-opacity:1;stroke:#ffffff;stroke-width:0.264583;stroke-opacity:1" />
                                <path
                                    d="m 262.80536,98.71315 c 0.0794,-0.243681 0.42413,-0.243681 0.50324,0 l 0.2831,0.871008 a 0.26458333,0.26458333 0 0 0 0.25135,0.182563 h 0.91599 c 0.25638,0 0.36275,0.328079 0.15558,0.478899 l -0.74084,0.53816 a 0.26458333,0.26458333 0 0 0 -0.0963,0.2958 l 0.28311,0.87101 c 0.0794,0.24368 -0.19976,0.44662 -0.40746,0.29581 l -0.74083,-0.53817 a 0.26458333,0.26458333 0 0 0 -0.31089,0 l -0.74083,0.53817 c -0.20743,0.15081 -0.48631,-0.0521 -0.4072,-0.29581 l 0.28311,-0.87101 a 0.26458333,0.26458333 0 0 0 -0.0963,-0.2958 l -0.74057,-0.5379 c -0.20717,-0.15081 -0.10054,-0.478895 0.15558,-0.478895 h 0.91572 a 0.26458333,0.26458333 0 0 0 0.25162,-0.182562 l 0.2831,-0.871009 z"
                                    id="path132-3"
                                    style="fill:#ffffff;fill-opacity:1;stroke-width:0.264583"
                                    clip-path="url(#clipPath954)"
                                    transform="translate(2.8128463,0.08967728)" />
                            </g>
                        </svg>
                    </template>
                    <template v-for="star in 5 - Math.ceil(selection.star_rating)">
                        <StarIconOutline class="text-white h-4.5 w-3 mr-0.5 my-1.5" />
                    </template>
                </div>
            </div>
        </div>

        <div :class="getStyles(selection).border" class="border dark:bg-gray-800 text-white p-2 rounded-b w-20 text-center text-xs uppercase" v-if="hasResult(selection)"><strong>{{ getPoints(selection) }} Points</strong></div>
        <div :class="getStyles(selection).border" class="border dark:bg-gray-800 text-white p-2 rounded-b w-20 text-center text-xs uppercase" v-if="hasResult(selection)"><strong>{{ getPoints(selection) }} Points</strong></div>
    </div>

        <span class="flex items-end justify-center text-center mr-1 my-auto h-10">

            <button v-if="selectedBooster.booster == 0" @click="selectBoost()" class="ml-1 rounded-full flex flex-row p-1 rounded-md w-20 h-10 text-center my-auto border-2 text-sm cursor-pointer" :class="[$page.props.settings.site_name == 'Racing Stars' ? 'bg-purple-700 border-purple-200 hover:bg-purple-500' : 'bg-gray-700 border-gray-200 hover:bg-gray-500']">
                <p v-if="$page.props.settings.site_name == 'Racing Stars'" class="text-white text-xs font-semibold my-auto pr-1">Boost</p>
                <p v-else class="text-white text-xs font-semibold my-auto pr-1">Apply</p>

                <LightningBoltIcon v-if="$page.props.settings.site_name == 'Racing Stars'" class="w-7 text-purple-200 stroke-current border-2 rounded-full bg-purple-800 border-purple-200 my-auto"/>
                <img v-else :src="asset('images/racingleague/joker.png')" class="w-7 my-auto"/>
            </button>

            <tw-modal v-if="$page.props.settings.site_name == 'Racing Stars'" :show="showBoostBetModal" title="Apply Booster" subtitle="Which boost would you like to apply to your chosen horse?" :padding="true" @close="showBoostBetModal = false">
                    <div v-for="booster in $page.props.boosters" class="flex flex-col mt-1">

                        <button :disabled="(userBoosters[booster.db_tag] == 0) && (!$page.props.features.infinite_boosters)" v-if="!selectedBooster.booster" @click="changeBooster(booster, selection.id)" :class="[ (userBoosters[booster.db_tag] == 0) && (!$page.props.features.infinite_boosters)  ? 'opacity-50' : 'opacity-100' , 'bg-gradient-to-br from-gray-500 to-gray-700 p-2 my-1 hover:from-gray-600 hover:to-gray-800 active:from-purple-400 border-2 border-gray-600 hover:border-gray-600 rounded-full flex justify-between w-full']">
                            <span class="flex max-w-12">
                                <img class="w-fit h-fit mr-2" :src="booster.new_img">

                                <p class="my-auto font-semibold">{{booster.name}}</p>
                            </span>

                            <span class="flex">
                                <p v-if="!$page.props.features.infinite_boosters" class="rounded-full bg-purple-500 text-xs text-white h-4 px-1 my-auto align-top font-semibold mr-2">{{userBoosters[booster.db_tag]}} Owned</p>
                                <PlusIcon class="w-8 h-8 text-purple-400 stroke-current border-2 rounded-full border-purple-400 p-1 my-auto mr-1"/>
                            </span>
                        </button>
                    </div>


                    <div class="flex items-center justify-center">
                        <tw-button @click="showBoostBetModal = false" class="mt-4">Cancel</tw-button>
                    </div>
            </tw-modal>

            <tw-modal v-else :show="showBoostBetModal" title="Apply Joker" subtitle="Confirm your joker selection." :padding="true" @close="showBoostBetModal = false">
                    <div v-for="booster in $page.props.boosters" class="flex flex-col mt-1">

                        <button :disabled="(userBoosters[booster.db_tag] == 0) && (!$page.props.features.infinite_boosters)" v-if="!selectedBooster.booster" @click="changeBooster(booster, selection.id)" :class="[ (userBoosters[booster.db_tag] == 0) && (!$page.props.features.infinite_boosters)  ? 'opacity-50' : 'opacity-100' , 'bg-gradient-to-br from-gray-500 to-gray-700 p-2 my-1 hover:from-gray-600 hover:to-gray-800 active:from-purple-400 border-2 border-gray-600 hover:border-gray-600 rounded-full flex justify-between w-full']">
                            <span class="flex max-w-12">
                                <img class="h-10 mr-2" :src="booster.new_img">
                                <p class="my-auto font-semibold">{{booster.name}}</p>
                            </span>

                            <span class="flex">
                                <p v-if="!$page.props.features.infinite_boosters" class="rounded-full bg-purple-500 text-xs text-white h-4 px-1 my-auto align-top font-semibold mr-2">{{userBoosters[booster.db_tag]}} Owned</p>
                                <PlusIcon class="w-8 h-8 text-purple-400 stroke-current border-2 rounded-full border-purple-400 p-1 my-auto mr-1"/>
                            </span>
                        </button>
                    </div>


                    <div class="flex items-center justify-center">
                        <tw-button @click="showBoostBetModal = false" class="mt-4">Cancel</tw-button>
                    </div>
            </tw-modal>
        </span>
</template>

<script>
    import { LightningBoltIcon, PlusIcon, StarIcon as StarIconOutline } from '@heroicons/vue/outline'
    import { onMounted, ref, toRaw } from 'vue'
    import Popper from 'vue3-popper'
    import { StarIcon, InformationCircleIcon } from '@heroicons/vue/solid'

    export default {
        props: {
            selection: {
                type: Object,
                default: {}
            },
            results: {
                type: Object,
                default: {}
            },
            selectedBooster: {
                type: Object,
                default: {}
            },
        },

        emits: ['changeBooster'],

        setup(props, { emit }) {
            const showBoostBetModal = ref(false)

            const userBoosters = ref(0)

            const getBoosters = () => {
                axios.get(route('api.boosters.get'))
                    .then(response => {
                        userBoosters.value = response.data
                    }
                );
            }

            onMounted(() => {
                getBoosters()
            })

            const changeBooster = (booster, runner) => {
                props.selectedBooster.booster = booster;
                props.selectedBooster.runner = runner;

                emit('changeBooster', props.selectedBooster)

                showBoostBetModal.value = false
            }

            const hasResult = (selection) => {
                let hasResult = false

                Object.keys(props.results).forEach(key => {
                    if (props.results[key].runner_id === selection.id) {
                        hasResult = true
                    }
                })

                return hasResult
            }

            const selectBoost = () => {
                showBoostBetModal.value=true
            }

            const getPoints = (selection) => {
                let points = 0

                Object.keys(props.results).forEach(key => {
                    if (props.results[key].runner_id === selection.id) {
                        points = props.results[key].points
                    }
                })

                return points
            }

            const getPosition = (selection, ordinal = true) => {
                let position = 0

                Object.keys(props.results).forEach(key => {
                    if (ordinal) {
                        if (props.results[key].runner_id === selection.id) {
                            position = props.results[key].race_outcome_description
                        }
                    } else {
                        if (props.results[key].runner_id === selection.id) {
                            position = props.results[key].position
                        }
                    }
                })

                return position
            }

            const getStyles = (selection) => {

                let classes = 'dark:bg-gray-600 text-white'
                let borderClass = 'border-transparent'

                let position = getPosition(selection, false)
                let points = getPoints(selection) !== 0

                if (position === 1 && points) {
                    borderClass = 'border-yellow-300'
                    classes = 'bg-gradient-to-r from-yellow-300 via-yellow-200 to-yellow-300 text-gray-800'
                }


                if (position === 2 && points) {
                    borderClass = 'border-gray-300'
                    classes = 'bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 text-gray-800'
                }

                if (position === 3 && points) {
                    borderClass = 'border-yellow-700'
                    classes = 'bg-gradient-to-r from-yellow-700 via-yellow-600 to-yellow-700 text-gray-800'
                }

                if (position === 4 && points) {
                    borderClass = 'border-gray-800'
                    classes = 'bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 text-white'
                }

                return {
                    styles: classes,
                    border: borderClass
                }
            }

            return {
                changeBooster,
                hasResult,
                getPoints,
                getPosition,
                getStyles,
                LightningBoltIcon,
                PlusIcon,
                showBoostBetModal,
                userBoosters,
                selectBoost,
            }

        },

        data() {
            return {
                boosters:  [
                    {"name" : "Double Points", "tag" : "2", "db_tag" : "times_two_multiplier", "img" : "/images/boosts/double-points.svg"},
                    {"name" : "Triple Points", "tag" : "3", "db_tag" : "times_three_multiplier", "img" : "/images/boosts/triple-points.svg"},
                    {"name" : "5x Points", "tag" : "5", "db_tag" : "times_five_multiplier", "img" : "/images/boosts/quintuple-points.svg"},
                    {"name" : "10x Points", "tag" : "10", "db_tag" : "times_ten_multiplier", "img" : "/images/boosts/decuple-points.svg"},
                    {"name" : "(Coming Soon)", "tag" : "DoubleSelection", "db_tag" : "double_runner", "img" : "/images/boosts/double-runner.svg"}
                ],
                showPercentage:this.getStoredProbabilityPref(),
            };
        },

        methods: {
            getOddsDescription(oddsDescription) {
                // If oddsDescription has no value return 'no odds'.
                if (!oddsDescription)
                    return 'No Odds';

                // If the api returns 'Evs' for probability return the same.
                else if (oddsDescription === 'Evs')
                    return oddsDescription;

                // If showPercentage is toggled convert given description to percentage and return.
                if (this.showPercentage) {
                    const oddsSplit = oddsDescription.split('/');

                    return parseFloat((Number(oddsSplit[1]) / (Number(oddsSplit[1]) + Number(oddsSplit[0])) * 100).toPrecision(2)) + "%";
                }

                // If show percentage is not toggled return oddsDescription as a fraction.
                return oddsDescription;
            },


            // Get stored implied probability preference from local user storage
            getStoredProbabilityPref() {
                let storedProbabilityPref = localStorage.getItem('showImpliedProbability')

                if (storedProbabilityPref) {
                    return (localStorage.getItem('showImpliedProbability') === 'true')
                }

                return false
            },

        },

        components: {
            StarIcon,
            StarIconOutline,
            LightningBoltIcon,
            PlusIcon,
            Popper,
            InformationCircleIcon,
        },
    }
</script>
